import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import classNames from 'classnames';
import { SelfServeBuilderPopupTypes } from 'Popups';

const { MULTIPLE_CHOICE } = SelfServeBuilderPopupTypes;

class PopupGroupBoxListItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onLabelFocus = this.onLabelFocus.bind(this);
    this.onLabelChange = this.onLabelChange.bind(this);
  }

  onLabelFocus() {
    this.props.onLabelFocus(this.props.id);
  }

  onLabelChange(e) {
    this.props.onLabelChange(this.props.id, e);
  }

  render() {
    const isMultipleChoice = this.props.type === MULTIPLE_CHOICE;
    const groupPopupListItemClasses = classNames(
      'group-box-popup-li',
      {
        active: this.props.activePopup === this.props.id,
        'group-box-multiple-choice': isMultipleChoice,
      },
    );

    const typeName = isMultipleChoice ? 'Choice' : 'Checkbox';
    return (
      <li
        className={groupPopupListItemClasses}
      >
        <div className="group-box-icon-wrapper" />
        <div className="group-box-label-wrapper">
          <TextareaAutosize
            className="box-popup-name-input-textarea"
            maxRows={9}
            onChange={this.onLabelChange}
            onFocus={this.onLabelFocus}
            onResize={this.props.onResize}
            placeholder={`${typeName} Name ${this.props.index + 1}...`}
            rows={1}
            value={this.props.value}
          />
        </div>
      </li>
    );
  }
}

PopupGroupBoxListItem.defaultProps = {
  value: '',
  type: 'checkbox',
};

PopupGroupBoxListItem.propTypes = {
  activePopup: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onLabelChange: PropTypes.func.isRequired,
  onLabelFocus: PropTypes.func.isRequired,
  onResize: PropTypes.func.isRequired,
  value: PropTypes.string,
  type: PropTypes.string,
};

export default PopupGroupBoxListItem;



// WEBPACK FOOTER //
// ./src-react/PopupGroup/PopupGroupBoxListItem.jsx